import type { FunctionComponent } from 'react'
import React from 'react'
import { Button, Modal } from '@arvoreeducacao/bonsai-ds'
import { useVoiceControl, getVoiceStrings } from 'context/voice-control'

import * as S from './ModalVoiceHelp.styles'

const ModalVoiceConfirm: FunctionComponent = () => {
  const voice = useVoiceControl()

  if (!voice.isConfirmOpen) return null

  const strings = getVoiceStrings(voice.locale)

  const handleEnable = () => {
    voice.closeConfirm()
    voice.enable()
  }

  return (
    <Modal
      title={strings.confirmTitle}
      isOpen={true}
      type="standard"
      size="small"
      onClose={voice.closeConfirm}
      hasDesktopCloseButton
      titleSize={4}
      center
      sheetHeaderProps={{
        title: strings.confirmTitle,
        type: 'close'
      }}
      portalContainer={document.getElementById('modal')}
    >
      <S.Wrapper>
        <S.Intro>{strings.confirmDescription}</S.Intro>
        <S.Actions>
          <Button
            theme={{ type: 'primaryLivros', size: 'large' }}
            text={strings.confirmEnable}
            fluid
            onClick={handleEnable}
          />
          <Button
            theme={{ type: 'secondary', size: 'large' }}
            text={strings.confirmCancel}
            fluid
            onClick={voice.closeConfirm}
          />
        </S.Actions>
      </S.Wrapper>
    </Modal>
  )
}

export default ModalVoiceConfirm
